<template>
<div>
  <div v-if="isLoading" class="loader-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    <div class="container-fluid">
            <div class="llp-container-section heightcontainer">
                <top-header id="height2"></top-header>
                <main-menu id="height3"></main-menu>
                <div class=" menu-margin-top">
                    <div class="searchBlock row pb-4 px-3 ml-0">
                      <div class="col-sm-12 mt-3 mb-4">
                        <ul class="navLinks">
                            <li>
                                <router-link :class="{ active: isActiveRoute('/mergeCustomers') }" class="linkItem" to="/mergeCustomers">Duplicate Customers</router-link>
                            </li>
                            <li>
                                <router-link :class="{ active: isActiveRoute('/mergedCustomersList') }" class="linkItem" to="/mergedCustomersList">Merged Customers</router-link>
                            </li>
                            <li>
                                <router-link :class="{ active: isActiveRoute('/customerActivityLog') }" class="linkItem" to="/customerActivityLog">Activity Log</router-link>
                            </li>
                        </ul>
                    </div>
                        <div class="col-sm-12 mb-4">
                            <h3>Manage Customers Merged Data</h3>
                        </div>
                        <div class="col-lg-2">
                      <label for="fname">First Name</label>
                      <input name='fname' type="text" 
                      placeholder="First Name"
                      v-model="searchObj.firstName"
                      autocomplete="off">
                  </div>
                  <div class="col-lg-2">
                      <label for="mname">Middle Name</label>
                      <input name='mname' type="text" 
                      placeholder="Middle Name"
                      v-model="searchObj.middleName"
                      autocomplete="off">
                  </div>
                  <div class="col-lg-2">
                      <label for="lname">Last Name</label>
                      <input name='lname' type="text" 
                      placeholder="Last Name"
                      v-model="searchObj.lastName"
                      autocomplete="off">
                  </div>
                  <div class="col-lg-2">
                      <label for="email">Email</label>
                      <input name='email' type="email" 
                      placeholder="Email"
                      v-model="searchObj.email"
                      autocomplete="off"
                      >
                  </div>
                  <div class="col-lg-2">
                      <label for="mobile">Mobile Number</label>
                      <input name='mobile' type="text" 
                      placeholder="Mobile Number"
                      v-model="searchObj.mobile"
                      autocomplete="off"
                      maxlength="14"
                      minlength="10"
                      @input="searchObj.mobile = $event.target.value.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')"
                      >
                  </div>
                  <div class="col-lg-2 btncontainer">
                      <button  @click="searchCustomerDebounce()"
                      :disabled ="searchButtonDisable()" >
                        Search
                      </button>
                  </div>
                  <div class="col-12 col-md-12">
                      <p class="clearText"><a @click="clearSearch()">Clear Search</a></p>
                  </div>
                    </div>
                    <div class="row tableContainer pt-5 pb-4 px-3 ml-0">
                  <div class="col-md-10">
                    <h3>Merged Data</h3>
                  </div>
                  <div class="col-md-2">
                    <!-- <button 
                    @click="confirmMerge"
                    :disabled="this.selectedPrimary.length<=0 || selectedSecondary.length<=0"
                    >Merge Selection</button> -->
                  </div>
                  <div class="col-12">
                    <!-- <table class="table table-responsive-sm mt-4 customerTable">
                      <thead class="tableHeading">
                        <tr>
                          <th style="width:10%">Customer Id</th>
                          <th style="width:15%">Name</th>
                          <th style="width:15%">Email</th>
                          <th style="width:15%">Mobile Number</th>
                          <th style="width:15%">Date of Merging</th>
                          <th style="width:10%">Status</th>
                          <th style="width:15%">Action</th>
                        </tr>
                      </thead> -->
                      <!-- <template> -->
                      <!-- <tbody v-if="customerList.length>0"> -->
                      <!-- <tbody> -->
                        <!-- <tr v-for="(customer,index) of customerList" :key="customer.customerId"> -->
                        <!-- <tr v-for="(customer,index) of customerList" :key="customer.customerId">
                          <td class="text-center align-middle">
                            <input  type="checkbox" id="keep" 
                            v-model="selectedPrimary" 
                            :value="customer.customerId"
                            @change="handleKeepChange(index)"
                            :disabled="primaryColumnDisabled && !selectedPrimary.includes(customer.customerId) || selectedSecondary.includes(customer.customerId)"
                            >
                          </td>
                          <td class="text-center align-middle">
                            <input  type="checkbox" id="merge"
                            v-model="selectedSecondary" 
                            :value="customer.customerId"
                            :disabled="selectedPrimary.includes(customer.customerId)"
                            >
                          </td>
                          <td class="tableCustomerId align-middle">customer.customerId</td>
                          <td class="tableName align-middle">customer.firstName + ' ' + customer.lastName</td>
                          <td class="tableEmail align-middle">customer.digitalContactInfo.email</td>
                          <td class="tableMobile align-middle">customer.digitalContactInfo.mobileNumber</td>
                          <td class="tableDate align-middle">customer.createdDate</td>
                          <td><button></button></td>
                        </tr> -->
                      <!-- </tbody> -->
                      <!-- <tbody v-else class="text-center">
                        noResult
                      </tbody> -->
                      <!-- </template>
                    </table> -->
                    <table class="table table-responsive-sm custom-table customerTable mt-4">
                          <thead style="border-bottom:1px" class="tableHeading">
                            <tr >
                              <th style="width:10%">Customer Id</th>
                              <th style="width:15%">Name</th>
                              <th style="width:20%">Email</th>
                              <th style="width:15%">Mobile Number</th>
                              <th style="width:15%">Status</th>
                              <th style="width:15%">Date of Merging</th>
                              <th style="width:10%;text-align:center">Action</th>
                            </tr>
                          </thead>
                          <template>
                          <tbody v-if="paginatedData.length>0">
                            <template v-for="(customerList, index) in paginatedData">
                              <tr v-for="(customer, idx) in customerList">
                                <td class="align-middle">{{ customer.customerId }}</td>
                                <td class="align-middle">{{ customer.firstName + ' ' + customer.middleName + ' ' + customer.lastName }}</td>
                                <td class="align-middle">{{ customer.digitalContactInfo.email }}</td>
                                <td class="align-middle">{{customer.digitalContactInfo.mobileNumber ? customer.digitalContactInfo.mobileNumber.replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3') : '-'}}</td>
                                <td :class="customer.status=='active' ? 'customerActive' : 'customerMerge'" class="align-middle">
                                  {{ customer.status=='active'? 'Active' : 'Merged'}}
                                </td>
                                <td v-if="idx===0" class="align-middle">{{customer.mergeDate}}</td>
                                <td v-if="idx === 0" rowspan="group.length" >
                                      <button @click="confirmUndoMerge(customerList[1].mergeGroupId)">Undo Merge</button>
                                    </td>
                              </tr>
                              <!-- Conditional border after each group -->
                              <tr v-if="index !== dataArray.length">
                                <td colspan="7" class="group-separator"></td>
                              </tr>
                            </template>
                          </tbody>
                          <tbody v-else class="text-center">
                        {{noResult}}
                          </tbody>
                          </template>
                      </table>
                  </div>
                </div>
                </div>
                <div class="mt-4 mb-5 pb-3">
                <b-pagination align="center" v-if="rows>perPage && paginatedData.length>0"
                     v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-number
                    last-number
                    @input="pagination"
                    class="customPagination"
                    ></b-pagination>
                </div>
                <!--confirm merge customer-->
        <div @click.self="isUnMergeConfirm = false" v-if="isUnMergeConfirm" class="modal" id="mergeSelect">
          <div class="modal-content">
            <div class="modal-heading">
              <h4>Unmerge Customers</h4>
            </div>
            <div class="modal-body">
              <img src="../assets/question.jpg" alt="" class="logo mt-2" />
              <p class="modalText mt-3 mb-4">
                Are you sure,<br> Do you want to unmerge customers ?
              </p>
              <!-- <img src="../assets/question.jpg" alt=""> -->
              <div class="d-flex justify-content-center mt-2 mb-1">

              <button
                type="button"
                class="btn mergeButton mx-2"
                @click="undoMerge()"
              >
                Undo Merge
              </button>
              <button type="button" @click="isUnMergeConfirm = false"  class="btn yesButton mx-2">Cancel</button>
              </div>
              
            </div>
          </div>
        </div>
        <!--confirm merge customer-->
        <!--successful merge dialog code start-->
        <div v-if="isSuccess" class="modal" id="successModal" @click.self="closeSuccess()">
          <div class="modal-content">
            <div class="modal-body">
              <img src="../assets/checkicon-min.png" alt="" class="logo" />
              <p class="modalText">
              {{unMergeSuccess}}
              </p>
            </div>
          </div>
        </div>
        <!--successful merge dialog code end-->
                <bottom-footer></bottom-footer>
            </div>
    </div>
</div>
</template>
<script>
import TopHeader from "@/components/TopHeader.vue";
import MainMenu from "@/components/Menu.vue";
import BottomFooter from "@/components/BottomFooter.vue";
import httpcommon from "../js/http-common.js";
import moment from 'moment';

export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter,
  },
  name: "mergedCustomersList",

  data() {
  return {
    searchObj : {
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        mobile: ''
        },
    customerList: [],
    currentPage: 1,
    rows: 0,
    perPage: 5,
    isMergeConfirm: false,
    isLoading: false,
    isSuccess: false,
    noResult: '',
    dataArray: [],
    isSearch: false,
    isSuccess: false,
    unMergeSuccess: false,
    isUnMergeConfirm: false,
    groupMergeId: '',
    paginatedData: []
  }
  },
  watch: {
     currentPage() {
      this.paginateData();
    },
    searchObj: {
      handler(newVal) {
        // if (newVal.mobile && !/^\d{0,10}$/.test(newVal.mobile)) {
        //   this.searchObj.mobile = newVal.mobile.replace(/\D/g, '');
        //   return; 
        // }
        const allFieldsCleared = !newVal.firstName.trim() &&
                                 !newVal.middleName.trim() &&
                                 !newVal.lastName.trim() &&
                                 !newVal.email.trim() &&
                                 !newVal.mobile ;

        const isMobileNumeric = newVal.mobile.trim() ? /^\d*$/.test(newVal.mobile.trim()) : true;

      if (allFieldsCleared && this.isSearch) {
        this.currentPage = 1
        this.getCustomerList();
      }else if (!isMobileNumeric) {
        // Prevent calling getCustomerList if mobile field has non-numeric input
        return;
      } }, // Adjust the debounce delay as needed
      deep: true,
    },
  },
  methods: {
    searchCustomerDebounce () {
      this.currentPage = 1
      this.paginatedData = []
      this.searchCustomer()
    },
    searchCustomer () {
    this.isLoading = true
    this.noResult = ''
  let searchParams = new URLSearchParams();
  if (this.searchObj.firstName) {
    searchParams.append('firstName', this.searchObj.firstName);
  }
  if (this.searchObj.middleName) {
    searchParams.append('middleName', this.searchObj.middleName);
  }
  if (this.searchObj.lastName) {
    searchParams.append('lastName', this.searchObj.lastName);
  }
  if (this.searchObj.email) {
    searchParams.append('email', this.searchObj.email);
  }
  if (this.searchObj.mobile) {
    searchParams.append('mobile', this.searchObj.mobile.replace(/\D/g, ''));
  }
    this.dataArray = []
    httpcommon
    .get(`/customer/filterMergedCustomerList?${searchParams.toString()}`)
    .then(response=>{
      this.isLoading = false
      this.isSearch = true
      if (response.data.length>0) {
      this.dataArray = response.data
      this.dataArray.forEach(customer=>{
        customer.forEach(obj=>{
        if(obj.mergeDate) {
            customer[0].mergeDate = moment(obj.mergeDate).format('Do MMM, YYYY')
          }
        })
      })
      this.rows = response.data.length
      this.paginateData()
      } else {
        this.noResult = 'No Result Found'
      }
      console.log(response)
    }).catch(error=>{
      this.isLoading = false
      this.errorslist.push(error)
    })
  },
  clearSearch () {
    const isSearch = this.searchObj.firstName== '' && this.searchObj.middleName== '' && this.searchObj.lastName== '' && this.searchObj.email== '' && this.searchObj.mobile== ''
      if (!isSearch) {
      this.searchObj.firstName= '',
      this.searchObj.middleName= '',
      this.searchObj.lastName= '',
      this.searchObj.email = '',
      this.searchObj.mobile= ''
      // this.customerList = []
      this.currentPage = 1
      this.noResult = ''
      // this.getCustomerList()
      }
    },
  searchButtonDisable () {
      // return  (!this.searchObj.firstName.trim() && !this.searchObj.middleName.trim() && !this.searchObj.lastName.trim() && !this.searchObj.email && !this.searchObj.mobile)
  //     const allFieldsEmpty = !this.searchObj.firstName.trim() && 
  //                        !this.searchObj.middleName.trim() && 
  //                        !this.searchObj.lastName.trim() && 
  //                        !this.searchObj.email.trim() && 
  //                        !this.searchObj.mobile.trim();
  
  // const isEmailValid = this.searchObj.email.trim() ? this.isValidEmail() : true;
  // const isMobileValid = /^\d{10}$/.test(this.searchObj.mobile.trim());
  // return allFieldsEmpty || !isEmailValid || !isMobileValid;

  const isFirstNameFilled = this.searchObj.firstName.trim() !== '';
  const isMiddleNameFilled = this.searchObj.middleName.trim() !== '';
  const isLastNameFilled = this.searchObj.lastName.trim() !== '';

  // Check if the email is valid or if it's empty
  const isEmailValid = this.searchObj.email.trim() ? this.isValidEmail() : true;

  // Check if the mobile field is valid (only numeric and 10 digits long) or if it's empty
  const isMobileValid = this.searchObj.mobile.trim() ? /^\d{10}$/.test(this.searchObj.mobile.trim().replace(/\D/g, '')) : true;

  // Disable the button if all fields are empty, or if email/mobile are invalid
  const isAnyFieldFilled = isFirstNameFilled || isMiddleNameFilled || isLastNameFilled || this.searchObj.email.trim() || this.searchObj.mobile.trim();

  return !isAnyFieldFilled || !isEmailValid || !isMobileValid;
  },
  isValidEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(this.searchObj.email.trim());
    },
    getCustomerList () {
    this.isLoading = true
    this.isSearch = false
    this.dataArray = []
    this.paginatedData = []
    this.noResult = ''
    // httpcommon.get(`/customer/getMergedCustomerList?page=${this.currentPage-1}&size=${this.perPage}`).then(response=>{
    httpcommon.get(`/customer/getMergedCustomerList`).then(response=>{
      this.isLoading = false
      if (response.data.length>0) {
      this.dataArray = response.data
      this.dataArray.forEach(customer=>{
        customer.forEach(obj=>{
          if(obj.mergeDate) {
            customer[0].mergeDate = moment(obj.mergeDate).format('Do MMM, YYYY');
          }
        })
      })
      console.log(response.data,'response.data')
      this.rows = response.data.length
      this.paginateData();
      }
    }).catch(error=>{
      this.isLoading = false
      this.errorslist.push(error)
    })
  },
  paginateData() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      this.paginatedData = this.dataArray.slice(start, end);
      console.log(this.paginatedData,'this.paginatedData')
    },
    pagination () {
    const checkProp = !this.searchObj.firstName.trim() && !this.searchObj.middleName.trim() && !this.searchObj.lastName.trim() && !this.searchObj.email.trim() && !this.searchObj.mobile.trim()
    // if (!checkProp && this.isSearch) {
    //   this.searchCustomer()
    // } else {
    //   this.getCustomerList()
    // }
    this.paginateData()
  },
  confirmUndoMerge (groupId) {
      this.isUnMergeConfirm = true
      this.groupMergeId = groupId
    },
  undoMerge () {
    httpcommon
    .get(`/customer/unmergeCustomers?mergeGroupId=`+this.groupMergeId)
    .then(response=>{
      this.isUnMergeConfirm = false
      this.isSuccess = true
      this.unMergeSuccess = response.data
        setTimeout(()=>{
          this.isSuccess=false
          this.groupMergeId = ''
          this.clearSearch()
          this.getCustomerList()
        },2000)
    }).catch(error=>{
      this.errorslist.push(error)
    })
  },
  isActiveRoute(route) {
      return this.$route.path === route;
    },
    retrieveData: function () {
      httpcommon
        .get("/userrole/")
        .then((response) => {
          this.userroles = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.errorslist.push(e);
        });
      httpcommon
        .get("/staticdata/status/")
        .then((response) => {
          this.status = response.data;
        })
        .catch((e) => {
          this.errorslist.push(e);
        });
    },
    myFunction() {
      var elmnt = document.getElementById("height2");
      var elmnt1 = document.getElementById("height3");
      var txt = elmnt.offsetHeight;
      var width = elmnt.offsetWidth;
      var txt1 = elmnt1.offsetHeight;
      var ht = txt + txt1;
      $("#employee").css("margin-top", txt + txt1 + 3);
    },
    menuheight () {
      var elmnt = document.getElementById("height2");
      var txt = elmnt.offsetHeight;
      $('#height3').css('margin-top', txt)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.myFunction()
    this.menuheight()
    this.getCustomerList()
  }
}
</script>
<style scoped >
.searchBlock {
  background-color: #F2F9FF;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  width: 100%;
}
.searchBlock h3 {
  font-weight: 600;
  color: #000000;
  line-height: 37.24px;
}
.searchBlock label {
  font: 400;
  font-size: 14px;
  color: #1C1B1F;
}
.searchBlock input {
  font: 400;
  font-size: 16px;
  color: #1C1B1F;
  border: 1px solid #E4ECF4;
  border-radius: 8px;
  padding: 10px;
  height: 44px;
  width: 100%;
}
/* .searchBlock input::placeholder {
color: #C5C5C5;
} */
.searchBlock button {
  border-radius: 8px;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 18px;
  background-color: #1E90FF;
  padding: 10px;
  height: 44px;
  width: 160px;
  border: none;
  width: 100%;
}
.btncontainer {
  padding-top: 30px;
}
 button:disabled {
  background-color: #9B9B9B !important;
  /* color: #000000; */
  /* cursor: none; */
}
.clearText {
  text-align: end;
  /* padding-right: 25px; */
  margin: 0;
}
.clearText a {
  cursor: pointer;
  color: #91a7bd ;
  font-weight: 400;
  font-size: 13px;
  text-decoration: underline;
}
.clearText a:hover {
  color: #1e90ff;
}
.tableContainer {
    width: 100%;
}
.tableContainer h3 {
  font-size: 24px;
  font-weight: 600;
  color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tableContainer button {
  background: #1E90FF ;
  border-radius: 8px;
  padding: 10px;
  width: 100%;
  color: #FFFFFF;
  border: none;
  font-weight: 600;
}
.customerTable {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  /* line-height: 32px; */
  table-layout:auto;
  width: 100% ;
}
.customerTable thead tr {
  color: #9B9B9B;
  font: 600 14px 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 32px;
}
.customerTable thead tr th {
    border-top: none;
    white-space: nowrap;
}
.customerTable tbody tr td {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  border: none;
  white-space: nowrap; /* Prevent cell text from wrapping */
}
tbody,thead {
  width: 100% !important;
}
thead tr {
  border-bottom: 1px solid #dbdbdb;
}
.customerTable .tableName {
  font-weight: 600;
  font-size: 16px;
}
 .custom-table {
  border-collapse: separate;
  border-spacing: 0;
}
.custom-table th,
.custom-table td {
  /* padding: 8px; */
  /* text-align: left; */
}
.custom-table tr {
  border-bottom: none;
}
.custom-table .group-separator {
  border-bottom: 1px solid #DBDBDB;
}
.custom-table tbody tr:last-child {
  border-bottom: none;
}
@media only screen and (max-width: 768px) {
    .customerTable {
        table-layout: auto; /* Allow table to adapt to screen width */
    }
}
.customerActive {
  color:#00AA00 !important;
  font-weight: 600 !important;
}
.customerMerge {
  color:#F22A0E !important;
  font-weight: 600 !important;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-heading {
  font-size: 14px;
}
.modal-heading::after {
  content:' ';
  height: 1px;
  background: #9B9B9B;
  width: 100%;
  display: block
}
.modal-content {
  border: #ffffff;
  background-color: #ffffff;
  padding: 36px 40px 36px 40px !important;
  width: 70vh !important;
  height: auto !important;
  max-height: 70vh;
  border-radius: 16px;
  text-align: center;
}
.modalText {
  font-size: 18px;
  font-weight: 400;
  line-height: 26.6px;
  color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.modal-body img {
  height:70px
}
.mergeButton,.yesButton {
  background-color: #1E90FF;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.28px;
  padding: 10px 20px;
  border-radius: 8px;
  /* margin: auto; */
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loader {
  border: 12px solid #f3f3f3;
  border-top: 12px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.navLinks {
    list-style: none;
    display: flex;
    padding-left: 0;
    justify-content: center;
}
.navLinks li {
    padding: 10px 35px 10px 0px;
}
.linkItem {
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
font-size: 18px;
font-weight: 600;
color: #8C8C8C;
Padding:10px 30px 10px 30px;
border-radius: 8px;
}
.linkItem:hover {
    color: #FFFFFF;
    background-color: #1E90FF;
}
.navLinks .active {
color: #FFFFFF !important;
background-color: #1E90FF;
}
.customPagination ::v-deep .page-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
}
.customPagination ::v-deep .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none ;
  height: 30px;
  width: 30px;
  margin: 0;
  padding: 10px;
  font-size: 20px;
  color: #9B9B9B;
}
.customPagination ::v-deep .active .page-link {
  background-color: #005DF1;
  border-radius: 8px;
  color: #FFFFFF;
}
.pagination.customPagination ::v-deep .page-item:first-child .page-link,
.pagination.customPagination ::v-deep .page-item:last-child .page-link {
  font-size: 40px !important; /* Adjust the font size as needed */
  padding: 0 20px 10px 20px;
}
</style>